import { render, staticRenderFns } from "./MainPopup.vue?vue&type=template&id=1f79ee61&scoped=true&"
import script from "./MainPopup.vue?vue&type=script&lang=js&"
export * from "./MainPopup.vue?vue&type=script&lang=js&"
import style0 from "./MainPopup.vue?vue&type=style&index=0&id=1f79ee61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f79ee61",
  null
  
)

export default component.exports